import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth';
import { Layout } from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Artists from './pages/Artists';
import Albums from './pages/Albums';
import Tracks from './pages/Tracks';
import Users from './pages/Users';
import Subscriptions from './pages/Subscriptions';
import AffiliatePayouts from './pages/AffiliatePayouts';
import Notifications from './pages/Notifications';
import Genres from './pages/Genres';
import AuditLog from './pages/AuditLog';

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="p-8 text-text2">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="artists" element={<Artists />} />
        <Route path="albums" element={<Albums />} />
        <Route path="tracks" element={<Tracks />} />
        <Route path="genres" element={<Genres />} />
        <Route path="users" element={<Users />} />
        <Route path="subscriptions" element={<Subscriptions />} />
        <Route path="affiliate-payouts" element={<AffiliatePayouts />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="audit-log" element={<AuditLog />} />
      </Route>
    </Routes>
  );
}
